module.exports = __webpack_public_path__ + "img/box.3345386.93f2482f.png";